<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户id"><el-input size="small" v-model="formInline.user_id" placeholder="请输入" clearable></el-input></el-form-item>
        <el-form-item label="用户手机号或昵称"><el-input size="small" v-model="formInline.username" placeholder="请输入" clearable></el-input></el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button type="primary" icon="el-icon-plus" size="small" @click="openPopup('add')" v-auth="'/user/credit/credit/add'">添加</el-button>
          <el-button size="small" type="success" @click="onExport" v-auth="'/user/credit/credit/export'">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" >
          <el-table-column prop="id" label="ID" width="80"></el-table-column>
          <el-table-column prop="user.nickName" label="微信头像" width="80" align="center">
            <template slot-scope="scope" v-if="scope.row.user">
              <div v-if="scope.row.user.avatarUrl">
                <img :src="scope.row.user.avatarUrl" width="50px" height="50px"/>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="user.nickName" label="昵称">
            <template slot-scope="scope" v-if="scope.row.user">
              <span>{{scope.row.user.nickName}}</span>
              <span class="gray9">(用户ID：{{scope.row.user.user_id}})</span>
            </template>
          </el-table-column>
          
          <el-table-column prop="mobile" label="手机号码">
            <template slot-scope="scope">
              <span v-if="scope.row.user">{{ scope.row.user.mobile }}</span>
            </template>
          </el-table-column>
          
          <el-table-column prop="price" label="授信额度"  align="center"></el-table-column>
          <el-table-column prop="used_price" label="已用额度"  align="center"></el-table-column>
          <el-table-column prop="surplus_price" label="剩余额度"  align="center"></el-table-column>
          
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button @click="openPopup('recharge', scope.row)" type="text" size="small" v-auth="'/user/credit/credit/recharge'">充值</el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small" v-auth="'/user/credit/credit/del'">删除</el-button>     
            </template>
            
          </el-table-column>
          
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <!--弹窗引入-->
    <Add v-if="show_popup['add']" :is_open="show_popup['add']" :oneform="Oneform" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <!--弹窗引入-->
    <Recharge v-if="show_popup['recharge']" :open_add="show_popup['recharge']" :form="Oneform.model" @closeDialog="closeDialogFunc($event, 'recharge')"></Recharge>
  </div>
</template>

<script>
  import CreditApi from '@/api/credit.js';
  import Add from './dialog/Add.vue';
  import Recharge from './dialog/Recharge.vue';
  import qs from 'qs';
  export default {
    components: {
      Add,
      Recharge,
    },
    data() {
      return {
        /*是否打开添加弹窗*/
        open_add: false,
        open_edit: false,
        /*选择的当前行对象数据*/
        Oneform:{
          type:'add',
          model:{}
        },
        show_track:false,
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          order_no: '',
          express_no: '',
        },
        dataModel:[],
        show_popup: {
          add: false,
          recharge: false,
        },
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        CreditApi.getCreditList(Params).then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.curPage = 1;
        let Params = self.formInline;
        self.getTableList();
      },
      
      /*打开弹窗*/
      openPopup(name, item){
        this.Oneform.type = name;
        if (name == 'edit') name = 'add';
        this.show_popup[name] = true;
        if(item&&typeof(item)!='undefined') this.Oneform.model = item;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.show_popup[f] = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      },

      /*删除*/
      delClick: function(row) {
        let self = this;
        self.loading = true;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {

          //请求接口
          CreditApi.delCredit({
            id: row.id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getTableList();
          }).catch(() =>{
            self.loading = false;
          });
        }).catch(() =>{
          self.loading = false;
        });
      },

      //导出
      onExport: function() {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/user.credit.credit/export?' + qs.stringify(this.searchForm);
      }

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/credit/credit.vue